import { useRef, useState } from "react";
import { api, mediaUrl } from "../lib/api";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";

export const ImageUpload = ({ value, onChange }) => {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    const form = new FormData();
    form.append("file", file);
    try {
      const { data } = await api.post("/upload", form, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Immagine caricata");
    } catch {
      toast.error("Caricamento fallito");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      <input ref={inputRef} type="file" accept="image/*" onChange={handleFile} className="hidden" data-testid="image-upload-input" />
      <button
        type="button"
        data-testid="image-upload-btn"
        onClick={() => inputRef.current?.click()}
        className="w-full rounded-xl border border-dashed border-white/20 bg-wyd-bg hover:border-wyd-accent transition-colors duration-200 overflow-hidden"
      >
        {value ? (
          <div className="relative h-40">
            <img src={mediaUrl(value)} alt="Anteprima" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-black/40 grid place-items-center opacity-0 hover:opacity-100 transition-opacity duration-200 text-white text-sm">
              Cambia immagine
            </div>
          </div>
        ) : (
          <div className="h-40 grid place-items-center text-wyd-muted">
            {uploading ? <Loader2 className="animate-spin text-wyd-accent" /> : (
              <div className="flex flex-col items-center gap-2"><Upload size={22} /><span className="text-sm">Carica immagine</span></div>
            )}
          </div>
        )}
      </button>
    </div>
  );
};
